/* eslint-disable @nx/enforce-module-boundaries */
import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  getGlobalColleges,
  createGlobalColleges,
} from 'v4/store/actions/global.data.actions';

export const useUniversities = ({ search, enabled = true }) => {
  const dispatch = useDispatch();
  const tid = useRef(-1);
  const {
    mutateAsync,
    mutate,
    isLoading: createLoading,
  } = useMutation({
    mutationKey: ['global-universities-create', search],
    mutationFn: async (payload) => {
      return dispatch(createGlobalColleges(payload));
    },
    onSuccess: () => {
      refetch();
    },
  });
  const {
    isLoading,
    isFetching,
    data = { pages: [] },
    fetchNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['global-universities', search],
    queryFn: async () => {
      const resp = await dispatch(getGlobalColleges({ search }));
      return resp?.payload;
    },
    getNextPageParam: (lastPage, pages) => {
      if (lastPage?.next) {
        const url = new URL(lastPage.next);
        const page = url.searchParams.get('page');
        return parseInt(page, 10);
      }
      return undefined;
    },
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading: isLoading || isFetching,
    createLoading,
    data,
    fetchNextPage,
    refetch,
    search,
    mutate,
    mutateAsync,
  };
};
